// A product page uses the redesigned layout when its content file declares
// format 2 (docs/mycanvas-product-page.md). Content only, no product-id checks.
export const usesProductPageLayout = (content) => content?.format === 2;
